import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/utils/config/config.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class PublicidadService {

  controller: string = "anuncio/";

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService,
  ) { }

  insert(file: File, element: any): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('titulo', element.titulo);
    formData.append('tipo', element.tipo);
    formData.append('url', element.url);
    formData.append('descripcion', element.descripcion);
    return this.http.post(this.config.apiUrl + this.controller + 'crear', formData, this.sesion.headersFile);
  }

  update(file: File, element: any): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('id', element.id);
    formData.append('titulo', element.titulo);
    formData.append('tipo', element.tipo);
    formData.append('url', element.url);
    formData.append('descripcion', element.descripcion);
    return this.http.post(this.config.apiUrl + this.controller + 'actualizar', formData, this.sesion.headersFile);
  }

  index_select(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'ver-select', this.sesion.headers);
  }

  deactivate(id: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'desactivar/' + id, {}, this.sesion.headers);
  }

  activate(id: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + "activar/" + id, {}, this.sesion.headers);
  }

  view(id: number): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + "ver/" + id, this.sesion.headers);
  }

  downloadFile(id: number): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'download/' + id, this.sesion.headersBlob);
  }

  delete(id: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + "eliminar/" + id, this.sesion.headers);
  }
}
